import Duck from 'extensible-duck'
import axios from "axios";
import { telcoSiteEndpoints } from "../api/endpoints";
import moment from "moment";
import UserAuthentication from "./UserAuthentication";
const authenticationActions = UserAuthentication.creators;

export default new Duck({
    namespace: 'AndromedaTelcoSites',
    store: 'telcosites',
    types: [
        'GET_THINGS', 'IS_LOADING' , 'GET_SITES' , 'CLEAR_SITES' ,  'GET_SITES_PAGINATED' ,'GET_COUNT' , 'GET_SINGLE_SITE'
    ],
    initialState: {
        things: null,
        isLoading: false,
        sites: [],
        siteCount:0,
        hasMoreItems: false,
        site:null
    },
    reducer: (state, action, duck) => {
        switch (action.type) {

            case duck.types.GET_THINGS:
                return {
                    ...state,
                    things: action.things
                }
            case duck.types.IS_LOADING:
                return {
                    ...state,
                    isLoading: action.isLoading
                };
                case duck.types.CLEAR_SITES:
                return {
                    ...state,
                    sites: [],
                };
                case duck.types.GET_SITES:
                    return {
                        ...state,
                        sites: [...state.sites, ...action.sites],
                    };
                    case duck.types.GET_SITES_PAGINATED:
                        return {
                            ...state,
                            sites: [...state.sites, ...action.sites],
                            hasMoreItems: action.sites.length > 0 ? true : false
                        };
                    case duck.types.GET_SINGLE_SITE:
                    return {
                        ...state,
                        site: action.site
                    };
                    case duck.types.GET_COUNT:
                    return {
                        ...state,
                        siteCount:action.siteCount

                    }

            default:
                return state;
        }
    },
    selectors: {
        root: state => state
    },
    creators: (duck) => ({

        getThings: (state) => async (dispatch) => {
            try {
                let data = {
                    companyId:state
                }
                const things = await axios.get(telcoSiteEndpoints.getThings , {params:data} )
                dispatch({ type: duck.types.GET_THINGS, things: things.data.data });
            } catch (error) {

            }
        },
        getTelcoSiteTour: (data) => async (dispatch , getState) => {
           try {

            const response = await axios.post(telcoSiteEndpoints.getTelcoSiteTour() , data);
            return response.data.data;
            
           } catch (error) {
                console.log(error)
                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
                throw error
           }
        },
        deleteSite: (state) => async(dispatch, getState) => {

            if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
                dispatch(authenticationActions.logoutUser());
            }
            if (getState().geoFence.isLoading) {
                // Don't issue a duplicate request (we already have or are loading the requested
                // data)
                return;
            }
            try {
                dispatch({type: duck.types.IS_LOADING, isLoading: true});
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
                await axios.delete(telcoSiteEndpoints.getSingleSite(state.id, companyInfo.groupId));

                dispatch({type: duck.types.IS_LOADING, isLoading: false});
            } catch (e) {
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
                throw e;
            }
        },
        bulkUpload: (state) => async(dispatch, getState) => {
            
            if (getState().telcosites.isLoading) {
                // Don't issue a duplicate request (we already have or are loading the requested
                // data)
                return;
            }
            try {
                dispatch({type: duck.types.IS_LOADING, isLoading: true});
               
                await axios.post(telcoSiteEndpoints.bulkUpload(state.groupId), {geofences: state.geofences});
                
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
            } catch (e) {
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
                throw e;
            }
        },
        getVehiclePath: (data, id) => async (dispatch , getState) => {
            try {

                if (getState().telcosites.isLoading) {
                    // Don't issue a duplicate request (we already have or are loading the requested
                    // data)
                    return;
                }
                const response = await axios.get(telcoSiteEndpoints.getVehiclePath(id), {
                    params: { data },
                  });
                  return response.data.data;
                
            } catch (error) {
                console.log(error)
                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
                throw error
            }
        },
        getSingleSite: (state) => async(dispatch, getState) => {
            if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
                dispatch(authenticationActions.logoutUser());
                return;
            }
            if (getState().telcosites.isLoading) {
                // Don't issue a duplicate request (we already have or are loading the requested
                // data)
                return;
            }
            try {
                dispatch({type: duck.types.IS_LOADING, isLoading: true});
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
                const response = await axios.get(telcoSiteEndpoints.getSingleSite(state.id, companyInfo.groupId));
                let site = response.data.data;
                dispatch({type: duck.types.GET_SINGLE_SITE, site});
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
            } catch (e) {
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
                throw e;
            }
        },
        getTelcoSites: (state) => async (dispatch , getState) => {

            try {

                if (getState().telcosites.isLoading) {
                    // Don't issue a duplicate request (we already have or are loading the requested
                    // data)
                    return;
                }
                dispatch({ type: duck.types.IS_LOADING, isLoading: true });
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));

                const response = await axios.get(telcoSiteEndpoints.getTelcoSites(companyInfo.groupId));
                let sites = response.data.data;
                dispatch({type: duck.types.GET_SITES, sites});
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
                return sites

                
            } catch (error) {
                console.log(error)
                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
                throw error
            }

        },
        getPaginatedSites: (search , clearRecord) => async(dispatch, getState) => {
            if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
                dispatch(authenticationActions.logoutUser());
                return;
            }
            if (getState().telcosites.isLoading) {
                return;
            }
            if(clearRecord){
                dispatch({type: duck.types.CLEAR_SITES});
              }
            
            try {
                dispatch({type: duck.types.IS_LOADING, isLoading: true});
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
                console.log(getState().telcosites.sites.length)
                let url = telcoSiteEndpoints.siteListPagin(companyInfo.groupId) + `?search=${search}&offset=${getState().telcosites.sites.length}`;
       
                const response = await axios.get(url);
                let {sites, siteCount} = response.data.data;
                dispatch({type: duck.types.GET_SITES_PAGINATED, sites});
                dispatch({type: duck.types.GET_COUNT, siteCount});
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
                return sites;
            } catch (e) {
                dispatch({type: duck.types.IS_LOADING, isLoading: false});
                throw e;
            }
        },
        UpdateSite: (state) => async (dispatch , getState) => {
            if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
                dispatch(authenticationActions.logoutUser());
            }
            if (getState().telcosites.isLoading) {
                // Don't issue a duplicate request (we already have or are loading the requested
                // data)
                return;
            }

            try {
                dispatch({ type: duck.types.IS_LOADING, isLoading: true });
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
                state.companyId = companyInfo.companyId;
                await axios.put(telcoSiteEndpoints.updateSite(state.id, companyInfo.groupId), state.siteObj);


                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
            } catch (e) {
                console.log(e)
                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
                throw e;
            }
        },
        CreateSite: (state) => async (dispatch, getState) => {
            if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
                dispatch(authenticationActions.logoutUser());
            }
            if (getState().telcosites.isLoading) {
                // Don't issue a duplicate request (we already have or are loading the requested
                // data)
                return;
            }

            try {
                dispatch({ type: duck.types.IS_LOADING, isLoading: true });
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
                state.companyId = companyInfo.companyId;
                await axios.post(telcoSiteEndpoints.createSite(companyInfo.groupId), state);


                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
            } catch (e) {
                console.log(e)
                dispatch({ type: duck.types.IS_LOADING, isLoading: false });
                throw e;
            }
        },

    })
})